import React, { Fragment, useEffect, useState } from 'react';

import { Table, Modal } from 'react-bootstrap';
import Navigator from 'Components/Shared/Navigator';
import { AiOutlinePlusCircle, AiOutlineUserAdd } from 'react-icons/ai';
import { toast } from 'react-toastify';

import EventService from 'Services/EventService';
import FonctionService from 'Services/FonctionService';

const EventsIndex = (props) => {
    const [event, setEvent] = useState([]);
    const [subscribers, setSubscribers] = useState([]);
    const [fonctions, setFonctions] = useState([]);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const {
        match: { params },
    } = props;

    useEffect(() => {
        EventService.getEventById(params.eventId)
            .then((result) => {
                if (result.status === 200) {
                    console.log(result.data);
                    setEvent(result.data);
                    setSubscribers(result.data.subscribers);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        FonctionService.getFonctions()
            .then((result) => {
                if (result.status === 200) {
                    setFonctions(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [params]);

    const createSubscription = (fonctionId) => {
        EventService.createSubscription(event.eventId, fonctionId)
            .then((result) => {
                if (result.status === 200) {
                    toast.success('Subscriber Created Successfully');
                    // setEvent(result.data);
                    setSubscribers([...subscribers, result.data]);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const deleteSubscription = (subscriberId) => {
        EventService.deleteSubscription(subscriberId)
            .then((result) => {
                if (result.status === 200) {
                    const data = subscribers.filter((item) => {
                        return item.subscriberId !== subscriberId;
                    });

                    setSubscribers(data);
                    handleClose();

                    toast.warning('Subscriber removed Successfully');
                    // setSubscribers([...subscribers, result.data]);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <Fragment>
            <>
                <Navigator section="Events" sectionUrl="event/index" action="Create New Event"></Navigator>
                <div className="d-flex justify-content-between align-items-center py-2">
                    <h2>Events Subscribers</h2>
                    <button className="btn btn-outline-primary btn-sm" onClick={handleShow}>
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </div>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Fonction Name</th>
                            <th className="text-center">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subscribers.length ? (
                            subscribers.map((subscriber, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{subscriber.fonctionId}</td>
                                        <td>{subscriber.fonction?.name}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn"
                                                onClick={() => {
                                                    deleteSubscription(subscriber.subscriberId);
                                                }}
                                            >
                                                <img
                                                    src="/images/delete.svg"
                                                    alt=""
                                                    style={{
                                                        height: '18pt',
                                                    }}
                                                />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5">no data</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ paddingTop: '0' }}>
                    <Table>
                        <tbody>
                            {fonctions.length ? (
                                fonctions
                                    .filter((a) => !subscribers.find((ac) => a.fonctionId === ac.fonctionId))
                                    .map((fonction, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>
                                                    {fonction.name}
                                                    <i
                                                        style={{
                                                            fontSize: '7pt',
                                                            display: 'block',
                                                            fontStyle: 'normal',
                                                        }}
                                                    >
                                                        {fonction.fonctionId}
                                                    </i>
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-primary"
                                                        onClick={() => {
                                                            createSubscription(fonction.fonctionId);
                                                        }}
                                                    >
                                                        <AiOutlineUserAdd></AiOutlineUserAdd>
                                                        <span className="ml-1">Subscribe</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                            ) : (
                                <tr>
                                    <td colSpan="2">no data</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default EventsIndex;
